import React, { useState } from 'react';
import { Modal, Form, Input, Alert } from 'antd';
import { connect } from 'react-redux';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { withUserType } from '../withUserType';
import OWButton from '../ow_button/OWButton';
import { rejectEntityAddRequest } from '../../thunks/entity_add_requests_thunks';

const FORM_ID = 'rejectEntityAddRequestForm';

// Second step of the approver reject flow: capture the (required) rejection reason.
function RejectEntityAddRequestModal({ visible, record, hideModal, onSuccess, rejectRequest }) {
	const [form] = Form.useForm();
	const [submitting, setSubmitting] = useState(false);
	const [errorMessage, setErrorMessage] = useState(undefined);

	const handleSubmit = (values) => {
		setErrorMessage(undefined);
		setSubmitting(true);
		rejectRequest(nullSafeGet('id', record), values.reason)
			.then(() => {
				setSubmitting(false);
				onSuccess();
			})
			.catch((error) => {
				setSubmitting(false);
				setErrorMessage(
					typeof error === 'string' ? error : 'Something went wrong rejecting this request.'
				);
			});
	};

	return (
		<Modal
			visible={visible}
			width={520}
			title="Reject Request"
			onCancel={hideModal}
			closable={true}
			destroyOnClose={true}
			footer={[
				<OWButton key="cancel" type="default" size="large" onClick={hideModal}>
					Cancel
				</OWButton>,
				<OWButton
					key="reject"
					type="primary"
					size="large"
					htmlType="submit"
					form={FORM_ID}
					loading={submitting}
				>
					Reject
				</OWButton>,
			]}
		>
			<Form id={FORM_ID} form={form} layout="vertical" preserve={false} onFinish={handleSubmit}>
				{errorMessage ? <Alert message={errorMessage} type="error" className="mb-4" /> : null}
				<Form.Item
					label="Reason for Rejection"
					name="reason"
					rules={[{ required: true, message: 'A rejection reason is required.' }]}
				>
					<Input.TextArea autoSize={{ minRows: 3 }} placeholder="Add a reason for rejection" />
				</Form.Item>
			</Form>
		</Modal>
	);
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
	rejectRequest: (id, reason) => dispatch(rejectEntityAddRequest(ownProps.userType)(id, reason)),
});

export default withUserType(
	connect(mapStateToProps, mapDispatchToProps)(RejectEntityAddRequestModal)
);
